import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import AppLayout from '../../commons/AppLayout/AppLayout';
import Products from './Products';

// Parse URLs here
const ProductsRouter = ({ match }) => (
  <AppLayout footer>
    <Switch>
      <Route
        path={`${match.path}/:category/:sub_category/:sub_sub_category/:brand`}
        render={({ match }) => {
          return (
            <Products
              category={match.params.category}
              subCategory={match.params.sub_category}
              subSubCategory={match.params.sub_sub_category}
              brand={match.params.brand}
            />
          );
        }}
      />
      <Route
        path={`${match.path}/:category/:sub_category/:sub_sub_category`}
        render={({ match }) => {
          return (
            <Products
              category={match.params.category}
              subCategory={match.params.sub_category}
              subSubCategory={match.params.sub_sub_category}
            />
          );
        }}
      />
      <Route
        exact
        path={`${match.path}/filtro/:filter`}
        render={({ match, ...props }) => (
          <Products customFilter={match.params.filter} {...props} />
        )}
      />
      <Route
        exact
        path={`${match.path}/marca/:brand`}
        render={({ match }) => <Products brand={match.params.brand} />}
      />
      <Route
        exact
        path={`${match.path}/:category/:sub_category`}
        render={({ match }) => (
          <Products
            category={match.params.category}
            subCategory={match.params.sub_category}
          />
        )}
      />
      <Route
        exact
        path={`${match.path}/favoritos`}
        render={() => <Products favorites />}
      />
      <Route
        exact
        path={`${match.path}/404`}
        render={() => <Products errorMessage />}
      />
      <Route
        path={`${match.path}/:category`}
        render={({ match }) => <Products category={match.params.category} />}
      />
      <Route exact path={match.path} component={Products} />
      <Redirect to={{ pathname: '/productos/404' }} />
    </Switch>
  </AppLayout>
);

export default withRouter(ProductsRouter);
